import { Country } from "../../types";

export const getCoverageUnit = (country: Country): string => {
  const unit = country === "USA" ? "miles" : "km";
  return unit;
};
